import { getPublicGroupsUserRequests } from "@/server/services/chatService";
import { useQuery } from "@tanstack/react-query";

export const usePublicGroupsUserRequests = (enabled?: boolean) => {
  /**
   * Custom hook to fetch public groups user requests.
   * @param {boolean} enabled - Whether the query should be enabled.
   * @returns {object} - Contains data, status, isFetching, error, and refetch function.
   */

  const { data, status, error, isFetching, refetch } = useQuery({
    queryKey: ["public-groups-user-requests"],
    queryFn: async () => {
      const response = await getPublicGroupsUserRequests();
      return response;
    },
    enabled: enabled,

    placeholderData: [],
  });

  return {
    data,
    status,
    isFetching,
    error,
    refetch,
  };
};
